class SwatchSelector extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Check if the URL has a variant parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    // Only select the middle option if no variant is present in the URL
    if (!variantId) {
      const radioButtons = this.querySelectorAll('.SizeSwatch__Radio');

      if (radioButtons.length > 0) {
        // Calculate the middle index
        const middleIndex = Math.ceil((radioButtons.length - 1) / 2);

        // Select the middle radio button by default
        radioButtons[middleIndex].checked = true;
      }
    }
  }
}

customElements.define('swatch-selector', SwatchSelector);
